/**
 * Action Cable helper for live admin notifications (top-bar bell).
 * Mirrors visitCable.js but streams the shared AdminNotificationsChannel.
 */
import { createConsumer } from '@rails/actioncable';

let consumer;

function getConsumer() {
  if (typeof window === 'undefined') return null;
  if (!consumer) consumer = createConsumer('/cable');
  return consumer;
}

/**
 * Subscribe to the admin notifications stream.
 * @param {(data: { notification: object, unread_count: number }) => void} onNotification
 * @returns {() => void} unsubscribe
 */
export function subscribeToAdminNotifications(onNotification) {
  const cable = getConsumer();
  if (!cable || typeof onNotification !== 'function') return () => {};

  const subscription = cable.subscriptions.create(
    { channel: 'AdminNotificationsChannel' },
    {
      received(data) {
        if (data?.notification) onNotification(data);
      },
    },
  );

  return () => {
    subscription.unsubscribe();
  };
}
